import { Typography, Box } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const FileItemContainer = styled(Box)`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid ${theme.palette.divider};
  border-radius: 8px;
  margin-bottom: 8px;
  background: ${theme.palette.background.paper};
`;

export const FilePreview = styled(Box)`
  width: 48px;
  height: 48px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.palette.grey[100]};
  margin-right: 12px;
  flex-shrink: 0;
`;

export const FileInfo = styled(Box)`
  flex: 1;
  min-width: 0;
`;

export const FileName = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
